import { addDataToQueryString } from '@/helpers/strings'
import { PaginatedData, PaginationReq } from './api.types'
import api from './api'
import {
  COMPLETED_COURSES,
  COURSES_CATEGORIES,
  COURSES_IN_PROGRESS,
  GET_LINKEDIN_AUTHORIZATION_URL,
  PASS_STATE_AND_CODE_TO_BACKEND,
  PUBLISHED_COURSES,
} from './endpoints'

export interface PublishedCourseListResDTO extends Course {}

export interface AttemptedCourseListResDTO {
  id: number
  course: Course
  is_completed: boolean
  certificate_url: string
  certificate_image_url: string
  certificate_valid: boolean
  certificate_verified: boolean
}

export interface AdminCompletedCourse {
  id: number
  requested_by: string
  course_title: string
  date_requested: string
  certificate_url: string
  certificate_verified: boolean
  certificate_fullname: string
  alumnus_name: string
  date_verified: string
  sections: Section[]
}

export interface VerifyCourseReqDTO {
  verified: boolean
  id: number
}

export type LinkedStateAndCodeReqDTO = {
  state: string
  code: string
}
export interface LinkedInCallbackResDTO {
  profile_id: string
  access_token: string
  refresh_token: string
  access_expiry: string
  refresh_expiry: string
  user: number
}

interface Course {
  id: number
  moodle_course_id: number
  category: string
  image_url: string
  course_url: string
  title: string
  description: string
  sections: Section[]
}

interface Section {
  name: string
  sub_sections: Subsection[]
}

interface Subsection {
  name: string
}
export interface Category {
  id: number
  name: string
}

export const getCoursesCategories = async () => {
  return (await api.get<{ data: Array<Category> }>(COURSES_CATEGORIES)).data
}

export const getPublishedCourses = async (
  payload: PaginationReq<{ category?: number }>
) => {
  const qs = addDataToQueryString('', payload)
  return (
    await api.get<{ data: PaginatedData<PublishedCourseListResDTO> }>(
      PUBLISHED_COURSES + (qs ? '?' + qs : '')
    )
  ).data
}

export const getPublishedCourseDetail = async (payload: number) => {
  return (
    await api.get<{ data: PublishedCourseListResDTO }>(
      PUBLISHED_COURSES + (payload + '/')
    )
  ).data
}

export const getAttemptedCourses = async (
  payload: PaginationReq<{
    category?: number
    is_completed: boolean
    alumnus_id?: number
  }>
) => {
  const qs = addDataToQueryString('', payload)
  return (
    await api.get<{ data: PaginatedData<AttemptedCourseListResDTO> }>(
      COURSES_IN_PROGRESS + (qs ? '?' + qs : '')
    )
  ).data
}

export const getAttemptedCourseDetail = async (payload: number) => {
  return (
    await api.get<{ data: AttemptedCourseListResDTO }>(
      COURSES_IN_PROGRESS + (payload + '/')
    )
  ).data
}

export const getAdminCourses = async (
  payload: PaginationReq<{ status: 'pending' | 'verified' }>
) => {
  const qs = addDataToQueryString('', payload)
  return (
    await api.get<{ data: PaginatedData<AdminCompletedCourse> }>(
      COMPLETED_COURSES + (qs ? '?' + qs : '')
    )
  ).data
}

export const getAdminCourseDetail = async (payload: number) => {
  return (
    await api.get<{ data: AdminCompletedCourse }>(
      COMPLETED_COURSES + (payload + '/')
    )
  ).data
}

export const adminVerifyCourse = async (payload: VerifyCourseReqDTO) => {
  return await api.patch<{ data: VerifyCourseReqDTO }>(
    COMPLETED_COURSES + (payload.id + '/'),
    payload
  )
}

export const uploadCourseCertificate = async (payload: FormData) => {
  return await api.post<{ data: AttemptedCourseListResDTO }>(
    COURSES_IN_PROGRESS + (payload.get('id') + '/certificate/'),
    payload
  )
}

export const shareCourseCertificate = async (payload: {
  id: number
  accessToken: string
}) => {
  return await api.post<{ data: AttemptedCourseListResDTO }>(
    COURSES_IN_PROGRESS + (payload.id + '/share-certificate/'),
    payload,
    { headers: { Authorization: 'Bearer ' + payload.accessToken } }
  )
}

export const getLinkedInAuthorizationUrl = async () => {
  return (
    await api.get<{ data: { url: string } }>(GET_LINKEDIN_AUTHORIZATION_URL)
  ).data
}

export const sendStateAndCodeToBackend = async (
  payload: LinkedStateAndCodeReqDTO
) => {
  const qs = addDataToQueryString('', payload)
  return (
    await api.get<{ data: LinkedInCallbackResDTO }>(
      PASS_STATE_AND_CODE_TO_BACKEND + (qs ? '?' + qs : '')
    )
  ).data
}
